export default __webpack_public_path__ + "img/tierra del fuego.4f394cd0.jpg";